import { UserConfigKey, useUserConfig } from "@kamae-apps/shared/Hooks/userConfig/useUserConfig"
import { FC, useEffect, useState } from "react"
import { useUser } from "../../Contexts/User/UserContext"
import { WelcomeModal } from "./WelcomeModal"
import { WelcomeModalV1User } from "./WelcomeModalV1User"

enum UserTypeEnum {
  V1 = "v1",
  V2 = "v2",
}

export const WelcomeModalRouter: FC = () => {
  const { user } = useUser()
  const { configs, setConfig } = useUserConfig()
  const [userType, setUserType] = useState<UserTypeEnum | null>(null)

  useEffect(() => {
    if (!configs) return

    const v1User = configs.get(UserConfigKey.FIRST_CONNECTION) && !user.avatar
    const v2User = configs.get(UserConfigKey.FIRST_CONNECTION) !== "true" && user.avatar

    if (v1User) {
      setUserType(UserTypeEnum.V1)
    } else if (v2User) {
      setUserType(UserTypeEnum.V2)
    }
  }, [configs, user])

  if (userType === UserTypeEnum.V1) return <WelcomeModalV1User close={() => setUserType(null)} />
  if (userType === UserTypeEnum.V2)
    return (
      <WelcomeModal
        close={async () => {
          await setConfig(UserConfigKey.FIRST_CONNECTION, "true")
          setUserType(null)
        }}
      />
    )
  return null
}
